export var LicenseQueryKey;
(function (LicenseQueryKey) {
    LicenseQueryKey["Info"] = "LicenseInfo";
    LicenseQueryKey["Credits"] = "LicenseCredits";
    LicenseQueryKey["BillingCompany"] = "LicenseBillingCompany";
})(LicenseQueryKey || (LicenseQueryKey = {}));
